import React from 'react';
import { navigate } from 'gatsby-link';
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'


const API_KEY = process.env.REACT_APP_MG_API_KEY
const DOMAIN = process.env.REACT_APP_MG_DOMAIN

const formData = require('form-data');
const Mailgun = require('mailgun.js');
const mailgun = new Mailgun(formData);
const client = mailgun.client({username: 'api', key: API_KEY});


let num;
const handleDragStart = (e) => e.preventDefault();

function encode(data) {
  const formData = new FormData()


  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }

  return formData

}


class KalKsia extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleAttachment = e => {
    this.setState({ [e.target.name]: e.target.files[0] })
  }

  handleSubmit = e => {


    let fileinput = document.getElementById('fileinput');
    let file = fileinput.files[0];


    if (file !== undefined){
        if (file.size < 1048576){
        e.preventDefault()
        const form = e.target;


            let formdata
            formdata = encode({
             'form-name': form.getAttribute('name'),
             ...this.state,
           })


              for (let value of formdata.values()) {
                 console.log(value);
              }

        fetch('/', {
          method: 'POST',
          body: formdata,
        })
          .then(() => {

            const messageData = {
              from: 'Art Open <bok@artopen.pl>',
              to: document.getElementById('adres emailVIII').value,
              subject: 'Thank you for sending your inquiry!',
              html: `
    <div style="background-color: #23c495; text-align: center">
    <a target="_blank" rel="noopener noreferrer" href="https://artopen.co/">
      <img
        src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/logo-mail.png?v=1651011958996"
        width="300px"
    /></a>
    </div>

    <div
    style="
      background-color: #23c495;
      display: flex;
      align-items: center;
      justify-content: center;
    "
    >
    <div style="display: block; text-align: left; color: white; padding: 20px">
      <h1 style="font-size: 1.5em">Thank you!</h1>
      <h2
        style="
          border-radius: 5px;
          border-bottom: 15px solid #fcc515;
          font-size: 2em;
          max-width: 80%;
        "
      >
        For sending a message from the Art Open website
      </h2>
      <sub style="margin-bottom: 20px"
        >Our team<strong> will contact you shortly.</strong><br />
        On business days <strong>we usually complete quotes within 24 hours</strong>.</sub
      >
    </div>
    <div>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://artopen.co/contact/"
        ><img src="https://artopen.co/img/newsletter.svg" width="100%"
      /></a>
    </div>
    </div>
    <br />
    <h3 style="font-size: 2em; text-align: center; margin-top: 30px">
    Get to know us better:
    <br />
    <sub style="font-size: 0.5em"
      >Get to know
      <a
        target="_blank"
        style="color: #23c495"
        rel="noopener noreferrer"
        href="https://artopen.co/about-us/"
        >who we are</a
      >.</sub
    >
    </h3>

    <div style="display: flex; justify-content: center">
    <a
      target="_blank"
      style="color: #23c495"
      rel="noopener noreferrer"
      href="https://artopen.co/offer/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l4.png?v=1651011237576"
          width="100%"
        /><br />
        <p style="text-align: center">OFFER</p>
      </div></a
    >
    <a
      target="_blank"
      style="color: #23c495"
      rel="noopener noreferrer"
      href="https://artopen.co/blog/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l3.png?v=1651011237576"
          width="100%"
        /><br />
        <p style="text-align: center">BLOG</p>
      </div></a
    >
    <a
      target="_blank"
      style="color: #23c495"
      rel="noopener noreferrer"
      href="https://artopen.co/portfolio/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l2.png?v=1651011237791"
          width="100%"
        /><br />
        <p style="text-align: center">PORTFOLIO</p>
      </div></a
    >
    <a
      target="_blank"
      style="color: #23c495"
      rel="noopener noreferrer"
      href="https://artopen.co/catalogs/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l1.png?v=1651011237864"
          width="100%"
        /><br />
        <p style="text-align: center">CATALOGS</p>
      </div></a
    >
    </div>
    <br /><br />
    <h3 style="text-align: center; font-size: 2em">
    Join the action:<br />
    <sub style="font-size: 0.5em"
      >Check out
      <a
        target="_blank"
        style="color: #23c495"
        rel="noopener noreferrer"
        href="https://artopen.co/blog/cleaning-action-open-for-environment-v-2/"
        >action footage in 2021</a
      >.</sub
    >
    </h3>
    <br /><br />
    <div style="display: block; text-align: center">
    <div>
      <img
        src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/akcja-sprzatanie-3.png?v=1651239639520"
        width="100%"
        style="min-width: 200px; max-width: 500px"
      />
    </div>
    <div
      style="
        display: block;
        text-align: center;
        padding-left: 0px;
        color: #23c495;
      "
    >
      <h1 style="font-size: 1.5em">
        Be ECO with us and join the Cleanup Action vol.III
      </h1>
      <p style="max-width:90%;margin-left:5%;">
        Being aware of the seriousness of the problem of littering, while being an agency with a strong pro-ecological profile at the same time, we decided to take matters into our own hands and for the third time we are organizing a local cleaning action.
        <br /><br /><br />
        <a
          style="
            color: #23c495;
            border-radius: 15px;
            padding: 10px 20px;
            border: 1px solid #23c495;
          "
          target="_blank"
          rel="noopener noreferrer"
          href="https://artopen.co/akcja-sprzatanie-vol-3/"
          >join us</a
        >
      </p>
    </div>
    </div>
    <br /><br />
    <h3 style="text-align: center; font-size: 2em">
    Check out the blog:<br />
    <sub style="font-size: 0.5em"
      >Read
      <a
        target="_blank"
        style="color: #23c495"
        rel="noopener noreferrer"
        href="https://artopen.co/blog/"
        >our articles</a
      >.</sub
    >
    </h3>
    <div
    style="
      background-color: #23c495;
      margin-top: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    "
    >
    <div style="display: block; text-align: left; padding: 20px; color: white">
      <h1 style="font-size: 2em">How to create a website?</h1>
      <p>
      What does web development look like and what does it consist of? Nowadays, a company website is a must have no matter the company’s profile. However, considering the competition online, simply having a website may not be enough.
        <br /><br /><br />
        <a
          style="
            color: white;
            border-radius: 15px;
            padding: 10px 20px;
            border: 1px solid white;
          "
          target="_blank"
          rel="noopener noreferrer"
          href="https://artopen.co/blog/jak-stworzyc-strone-internetowa/"
          >read more</a
        >
      </p>
    </div>
    <div>
      <img
        src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/jak.png?v=1651241484223"
        width="100%"
      />
    </div>
    </div>
    <br /><br /><br />
    <div style="display: flex; justify-content: center">
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://facebook.com/artopenstudioreklamy/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/fb.png?v=1651013201802"
          width="30px"
        /></div></a
    >&nbsp;&nbsp;
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://twitter.com/AReklamy/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/t.png?v=1651013201802"
          width="30px"
        /></div></a
    >&nbsp;&nbsp;
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.youtube.com/channel/UCR45VIn9iEmnQo7JU_FL2uQ/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/yt.png?v=1651013201802"
          width="30px"
        /></div></a
    >&nbsp;&nbsp;
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.linkedin.com/company/art-open-studio-reklamy/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l.png?v=1651013202010"
          width="30px"
        /></div></a
    >&nbsp;&nbsp;
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.behance.net/ArtOpenStudioReklamy/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/b.png?v=1651013202080"
          width="30px"
        /></div></a
    >&nbsp;&nbsp;
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.instagram.com/artopen.pl/"
      ><div>
        <img
          src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/i.png?v=1651013202263"
          width="30px"
        /></div></a
    >&nbsp;&nbsp;
    </div>

    <p style="text-align: center; font-size: 10px; margin-top: 10px">
    We hope you enjoy our content. If you don't
    <a
      target="_blank"
      style="color: #23c495"
      rel="noopener noreferrer"
      href="https://artopen.co/contact/"
      >here you can withdraw your subscriptions.</a
    >
    </p>
    <br /><br />

    `
            };
            console.log(client)

            client.messages.create(DOMAIN, messageData)
             .then((res) => {
               console.log(res);
             })
             .catch((err) => {
               console.error(err);
             });


            navigate('/contact/sukces/')
          }).catch(error => alert(error))
      } else {
        alert('The file is too large. The maximum size is 1MB, try again with a smaller file');
        }
    } else {
    e.preventDefault()
    const form = e.target;


        let formdata
        formdata = encode({
         'form-name': form.getAttribute('name'),
         ...this.state,
       })


          for (let value of formdata.values()) {
             console.log(value);
          }

    fetch('/', {
      method: 'POST',
      body: formdata,
    })
      .then(() => {

        const messageData = {
          from: 'Art Open <bok@artopen.pl>',
          to: document.getElementById('adres emailVIII').value,
          subject: 'Thank you for sending your inquiry!',
          html: `
<div style="background-color: #23c495; text-align: center">
<a target="_blank" rel="noopener noreferrer" href="https://artopen.co/">
  <img
    src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/logo-mail.png?v=1651011958996"
    width="300px"
/></a>
</div>

<div
style="
  background-color: #23c495;
  display: flex;
  align-items: center;
  justify-content: center;
"
>
<div style="display: block; text-align: left; color: white; padding: 20px">
  <h1 style="font-size: 1.5em">Thank you!</h1>
  <h2
    style="
      border-radius: 5px;
      border-bottom: 15px solid #fcc515;
      font-size: 2em;
      max-width: 80%;
    "
  >
    For sending a message from the Art Open website
  </h2>
  <sub style="margin-bottom: 20px"
    >Our team<strong> will contact you shortly.</strong><br />
    On business days <strong>we usually complete quotes within 24 hours</strong>.</sub
  >
</div>
<div>
  <a
    target="_blank"
    rel="noopener noreferrer"
    href="https://artopen.co/contact/"
    ><img src="https://artopen.co/img/newsletter.svg" width="100%"
  /></a>
</div>
</div>
<br />
<h3 style="font-size: 2em; text-align: center; margin-top: 30px">
Get to know us better:
<br />
<sub style="font-size: 0.5em"
  >Get to know
  <a
    target="_blank"
    style="color: #23c495"
    rel="noopener noreferrer"
    href="https://artopen.co/about-us/"
    >who we are</a
  >.</sub
>
</h3>

<div style="display: flex; justify-content: center">
<a
  target="_blank"
  style="color: #23c495"
  rel="noopener noreferrer"
  href="https://artopen.co/offer/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l4.png?v=1651011237576"
      width="100%"
    /><br />
    <p style="text-align: center">OFFER</p>
  </div></a
>
<a
  target="_blank"
  style="color: #23c495"
  rel="noopener noreferrer"
  href="https://artopen.co/blog/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l3.png?v=1651011237576"
      width="100%"
    /><br />
    <p style="text-align: center">BLOG</p>
  </div></a
>
<a
  target="_blank"
  style="color: #23c495"
  rel="noopener noreferrer"
  href="https://artopen.co/portfolio/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l2.png?v=1651011237791"
      width="100%"
    /><br />
    <p style="text-align: center">PORTFOLIO</p>
  </div></a
>
<a
  target="_blank"
  style="color: #23c495"
  rel="noopener noreferrer"
  href="https://artopen.co/catalogs/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l1.png?v=1651011237864"
      width="100%"
    /><br />
    <p style="text-align: center">CATALOGS</p>
  </div></a
>
</div>
<br /><br />
<h3 style="text-align: center; font-size: 2em">
Join the action:<br />
<sub style="font-size: 0.5em"
  >Check out
  <a
    target="_blank"
    style="color: #23c495"
    rel="noopener noreferrer"
    href="https://artopen.co/blog/cleaning-action-open-for-environment-v-2/"
    >action footage in 2021</a
  >.</sub
>
</h3>
<br /><br />
<div style="display: block; text-align: center">
<div>
  <img
    src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/akcja-sprzatanie-3.png?v=1651239639520"
    width="100%"
    style="min-width: 200px; max-width: 500px"
  />
</div>
<div
  style="
    display: block;
    text-align: center;
    padding-left: 0px;
    color: #23c495;
  "
>
  <h1 style="font-size: 1.5em">
    Be ECO with us and join the Cleanup Action vol.III
  </h1>
  <p style="max-width:90%;margin-left:5%;">
    Being aware of the seriousness of the problem of littering, while being an agency with a strong pro-ecological profile at the same time, we decided to take matters into our own hands and for the third time we are organizing a local cleaning action.
    <br /><br /><br />
    <a
      style="
        color: #23c495;
        border-radius: 15px;
        padding: 10px 20px;
        border: 1px solid #23c495;
      "
      target="_blank"
      rel="noopener noreferrer"
      href="https://artopen.co/akcja-sprzatanie-vol-3/"
      >join us</a
    >
  </p>
</div>
</div>
<br /><br />
<h3 style="text-align: center; font-size: 2em">
Check out the blog:<br />
<sub style="font-size: 0.5em"
  >Read
  <a
    target="_blank"
    style="color: #23c495"
    rel="noopener noreferrer"
    href="https://artopen.co/blog/"
    >our articles</a
  >.</sub
>
</h3>
<div
style="
  background-color: #23c495;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
"
>
<div style="display: block; text-align: left; padding: 20px; color: white">
  <h1 style="font-size: 2em">How to create a website?</h1>
  <p>
  What does web development look like and what does it consist of? Nowadays, a company website is a must have no matter the company’s profile. However, considering the competition online, simply having a website may not be enough.
    <br /><br /><br />
    <a
      style="
        color: white;
        border-radius: 15px;
        padding: 10px 20px;
        border: 1px solid white;
      "
      target="_blank"
      rel="noopener noreferrer"
      href="https://artopen.co/blog/jak-stworzyc-strone-internetowa/"
      >read more</a
    >
  </p>
</div>
<div>
  <img
    src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/jak.png?v=1651241484223"
    width="100%"
  />
</div>
</div>
<br /><br /><br />
<div style="display: flex; justify-content: center">
<a
  target="_blank"
  rel="noopener noreferrer"
  href="https://facebook.com/artopenstudioreklamy/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/fb.png?v=1651013201802"
      width="30px"
    /></div></a
>&nbsp;&nbsp;
<a
  target="_blank"
  rel="noopener noreferrer"
  href="https://twitter.com/AReklamy/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/t.png?v=1651013201802"
      width="30px"
    /></div></a
>&nbsp;&nbsp;
<a
  target="_blank"
  rel="noopener noreferrer"
  href="https://www.youtube.com/channel/UCR45VIn9iEmnQo7JU_FL2uQ/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/yt.png?v=1651013201802"
      width="30px"
    /></div></a
>&nbsp;&nbsp;
<a
  target="_blank"
  rel="noopener noreferrer"
  href="https://www.linkedin.com/company/art-open-studio-reklamy/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/l.png?v=1651013202010"
      width="30px"
    /></div></a
>&nbsp;&nbsp;
<a
  target="_blank"
  rel="noopener noreferrer"
  href="https://www.behance.net/ArtOpenStudioReklamy/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/b.png?v=1651013202080"
      width="30px"
    /></div></a
>&nbsp;&nbsp;
<a
  target="_blank"
  rel="noopener noreferrer"
  href="https://www.instagram.com/artopen.pl/"
  ><div>
    <img
      src="https://cdn.glitch.global/505caa55-4dac-4177-8df2-396cd54200e4/i.png?v=1651013202263"
      width="30px"
    /></div></a
>&nbsp;&nbsp;
</div>

<p style="text-align: center; font-size: 10px; margin-top: 10px">
We hope you enjoy our content. If you don't
<a
  target="_blank"
  style="color: #23c495"
  rel="noopener noreferrer"
  href="https://artopen.co/contact/"
  >here you can withdraw your subscriptions.</a
>
</p>
<br /><br />

`
        };
        console.log(client)

        client.messages.create(DOMAIN, messageData)
         .then((res) => {
           console.log(res);
         })
         .catch((err) => {
           console.error(err);
         });


        navigate('/contact/sukces/')
      }).catch(error => alert(error))
  }

}

  render() {
    return (
      <>
      <form
        name="Kalendarze książkowe"
        action="/contact/sukces/"
        id = "Kalksiaform"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
      >

      <input name='Kalendarze książkowe' id='Bookcalendars' className='subtitle' placeholder='Book Calendars:' disabled style={{color:'gray',fontFamily:'Poppins, sans-serif', backgroundColor:'white',border:'0px solid white',marginBottom:'20px',minWidth:'100%'}} />
      <div className='field' style={{marginLeft:'18px'}}>
      <div className='control'>
      <label className='label'>Quantity:</label>

        <input onChange={this.handleChange} style={{maxWidth:'200px'}} className='input' min='30' required={true} type='number' placeholder='100' name='Ilość kalendarzy' id='ilosck' />
      </div>
      <br />
          <div className='columns'>

          <div className='column'>
          <label className='label'>Calendar format:</label>
          <select selected="selected"
          className='button-green select-green' as='select'  name='Format' id='format'
          onChange={this.handleChange}
          >
          <option value="A6">A6</option>
          <option value="A5">A5</option>
          <option value="B5">B5</option>
          <option value="A4">A4</option>

          </select>
          </div>

          <div className='column'>
          <label className='label'>Type of measure:</label>
          <select selected="selected"
          className='button-green select-green' as='select'  name='Rodzaj środka' id='rodzajsrodka'
          onChange={this.handleChange}
          >
          <option value="dzienny">daily</option>
          <option value="tygodniowy">weekly</option>
          <option value="indywidualny">individual</option>
          </select>
          </div>






      </div>

      <div className='columns'>
      <div className='column'>

      <label className='label'>Paper type:</label>

      <select selected="selected"
      className='button-green select-green' as='select'  name='Rodzaj papieru' id='rodzajpapieru'
      onChange={this.handleChange}
      onInput={(event) => {
      console.log(event.target.value);
        if(event.target.value == 'standardowy'){
          document.getElementById('optionI').style.display = 'block';
          document.getElementById('optionII').style.display = 'none';

        } else {
          document.getElementById('optionI').style.display = 'none';
          document.getElementById('optionII').style.display = 'block';

        }
      }}
      >
      <option value="standardowy">standard</option>
      <option value="eco">eco</option>

      </select>


      </div>


      <div id='optionI' className='column'>
      <label className='label' >Color:</label>
      <select
      className='button-green select-green' as='select'  name='kolor papieru' id='kolorpapieru'
      onChange={this.handleChange}
      >
      <option value="biały">white</option>
      <option value="chamois">chamois</option>

      </select>
      </div>
      <div id='optionII' className='column' style={{display:'none'}}>
      <label className='label' id='optionII'>Eco paper:</label>
      <select
      className='button-green select-green' as='select'  name='Eko papier' id='eko papier'
      onChange={this.handleChange}
      >
      <option value="papier z trawy">grass paper</option>
      <option value="papier z kamienia">stone paper</option>

      </select>
      </div>
      </div>




      <br />
      <label className='label'>Framing Pattern:</label>
      <br />
      <div className='columns' style={{ display:'flex', flexWrap:'wrap'}}>
      <div className='column'>
        <label onClick={changeOne(0)} className="choicebtn">
          Savana
        </label>
        <br /><br />

        <label onClick={changeOne(1)} className="choicebtn">
          Bamboo
        </label>
        <br /><br />

        <label onClick={changeOne(2)} className="choicebtn">
          Nature
        </label>
        <br /><br />

        <label onClick={changeOne(3)} className="choicebtn">
          Canvas
        </label>
        <br /><br />
        <label onClick={changeOne(4)} className="choicebtn">
          Kraft
        </label>
        <br /><br />

        <label onClick={changeOne(5)} className="choicebtn">
          Vivela
        </label>
        <br /><br />
        <label onClick={changeOne(6)} className="choicebtn">
          Image
        </label>

      </div>
      <div className='column'>

        <label onClick={changeOne(7)} className="choicebtn">
          Ideo
        </label>
        <br /><br />

        <label onClick={changeOne(8)} className="choicebtn">
          Carbon
        </label>
        <br /><br />

        <label onClick={changeOne(9)} className="choicebtn">
          Cross
        </label>
        <br /><br />

        <label onClick={changeOne(10)} className="choicebtn">
        Rubber
        </label>
        <br /><br />

        <label onClick={changeOne(11)} className="choicebtn">
          Piko
        </label>
        <br /><br />
        <label onClick={changeOne(12)} className="choicebtn">
          Holo
        </label>
        <br /><br />
        <label onClick={changeOne(13)} className="choicebtn">
          Flesz
        </label>

      </div>

      <div className='column'>
          <label onClick={changeOne(14)} className="choicebtn">
            Aluminium
          </label>
          <br /><br />

          <label onClick={changeOne(15)} className="choicebtn">
          Outlet - Suede
          </label>
          <br /><br />
          <label onClick={changeOne(16)} className="choicebtn">
            Outlet - Duro
          </label>
          <br /><br />
          <label onClick={changeOne(17)} className="choicebtn">
            Outlet - Fabra
          </label>
          <br /><br />
          <label onClick={changeOne(18)} className="choicebtn">
            Outlet - Colorado
          </label>
          <br /><br />
          <label onClick={changeOne(19)} className="choicebtn">
            Outlet - Cross
          </label>
          <br /><br />
          <label onClick={changeOne(20)} className="choicebtn">
            Outlet - Juta
          </label>
        </div>
      </div>
      <br />


      {/* Obrazki radio buttons - kolory*/}
      <div className='columns' style={{textAlign:'center',marginLeft:'auto',marginRight:'auto',display:'flex',flexWrap:'wrap'}}>
      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor"  />
        <img loading="lazy" alt="binding I" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__czarny.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor" />
        <img loading="lazy" alt="binding II" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__czerwony.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor" />
        <img loading="lazy" alt="binding III" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__granatowy.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor"  />
        <img loading="lazy" alt="binding IV" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__magenta.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor"  />
        <img loading="lazy" alt="binding V" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__pomaranczowy.png" width='80px' />
      </label>
      &nbsp; &nbsp;



      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor"  />
        <img loading="lazy" alt="binding VI" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__seledynowy.png" width='80px' />
      </label>

      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor"  />
        <img loading="lazy" alt="binding VII" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__szary.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor" />
        <img loading="lazy" alt="binding VIII" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__turkusowy.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor" />
        <img loading="lazy" alt="binding IX" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__zielony.png" width='80px' />
      </label>
      &nbsp; &nbsp;

      <label style={{margin:'10px'}}>
        <input onChange={this.handleChange} className='koloroprawy' type="radio" name="kolor" />
        <img loading="lazy" alt="binding X" className='obrazek lazyload oprawaimg' src="/img/oprawy/Vivela__zolty.png" width='80px' />
      </label>


      </div>








      <br />
      <div className='columns'>
        <div className='column'>
        <label className='label'>Cladding:</label>
        <select selected="selected"
        className='button-green select-green' style={{minWidth:'200px'}} as='select'  name='Okładzina' id='Okładzina'
        onChange={this.handleChange}
        onInput={(event) => {
        console.log(event.target.value);
          if(event.target.value == 'oprawa z wzornika'){
            document.getElementById('UszlachetnieniaI').style.display = 'flex';
            document.getElementById('UszlachetnieniaII').style.display = 'none';

            for(let i=0;i<document.getElementsByClassName('u2').length;i++){
              document.getElementsByClassName('u2')[i].checked = false;
            }

          } else {
            document.getElementById('UszlachetnieniaI').style.display = 'none';
            document.getElementById('UszlachetnieniaII').style.display = 'flex';

            for(let i=0;i<document.getElementsByClassName('u1').length;i++){
              document.getElementsByClassName('u1')[i].checked =false;
            }

          }
        }}
        >
        <option value="oprawa z wzornika">template binding</option>
        <option value="oprawa papierowa z zadrukiem fullkolor">full-color paper binding</option>

        </select>
        </div>
      <div className='column'>
        <label className='label'>Tapestry:</label>

        <select selected="selected"
        className='button-green select-green' as='select'  name='Uszlachetnienia' id='Uszlachetnienia'
        onChange={this.handleChange}
        >
        <option value="standard">standard</option>
        <option value="indywidualna">individual</option>
        </select>
        </div>

      </div>
      <div>

      </div>

      <label className='label'>Refinements:</label>
      <br />



      <div className='control columns' id='UszlachetnieniaI' style={{display:'flex',flexWrap:'wrap',width:'100%',marginLeft:'3%'}}>
          <div className='column'>
            <label htmlFor="tloczenie" className='label main' style={{fontSize:'14px'}}>Stamping
            <input className='checkbox u1' onChange={this.handleChange} type='checkbox'  name='Tłoczenie' id='tloczenie' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label htmlFor="grawerlaserowy" className='label main' style={{fontSize:'14px'}}>Laser engraving
            <input className='checkbox u1' onChange={this.handleChange} type='checkbox'  name='Grawer laserowy' id='grawerlaserowy' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label className='label main' htmlFor="pattern" style={{fontSize:'14px'}}>Pattern
            <input className='checkbox u1' onChange={this.handleChange} type='checkbox'  name='Pattern' id='pattern' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label className='label main' htmlFor="przeszycie" style={{fontSize:'14px'}}>Artistic stitching
            <input className='checkbox u1' onChange={this.handleChange} type='checkbox'  name='Przeszycie artysytczne' id='przeszycie' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label className='label main' htmlFor="finochrom" style={{fontSize:'14px'}}>Finochrome
            <input className='checkbox u1' onChange={this.handleChange} type='checkbox'  name='Finochrom' id='finochrom' />
            <span className="check"></span>
            </label>
          </div>
      </div>

      <div className='control columns' id='UszlachetnieniaII' style={{display:'none',flexWrap:'wrap',width:'100%',marginLeft:'3%'}}>
        <div className='column'>
            <label htmlFor="folia mat" className='label main' style={{fontSize:'14px'}}>Matte foil
            <input className='checkbox u2' onChange={this.handleChange} type='checkbox'  name='Folia mat' id='folia mat' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label htmlFor="folia blysk" className='label main' style={{fontSize:'14px'}}>Gloss foil
            <input className='checkbox u2' onChange={this.handleChange} type='checkbox'  name='Folia błysk' id='folia blysk' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label className='label main' htmlFor="foliasoft" style={{fontSize:'14px'}}>Soft touch foil
            <input className='checkbox u2' onChange={this.handleChange} type='checkbox'  name='Folia soft touch' id='foliasoft' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label className='label main' htmlFor="metalprint" style={{fontSize:'14px'}}>Metal print
            <input className='checkbox u2' onChange={this.handleChange} type='checkbox'  name='Metal print' id='metalprint' />
            <span className="check"></span>
            </label>
          </div>
          <div className='column'>
            <label className='label main' htmlFor="lakieruv" style={{fontSize:'14px'}}>UV varnish
            <input className='checkbox u2' onChange={this.handleChange} type='checkbox'  name='Lakier UV' id='lakieruv' />
            <span className="check"></span>
            </label>
          </div>
      </div>








      <br />
      <label className='label'>Extras:</label>
      <br />
      </div>

      <div className="columns" style={{textAlign:'left',marginLeft:'20px',flexWrap:'wrap'}}>

      <div className='column'>
      <label htmlFor='c1' className='main kmain'>
        <input onChange={this.handleChange} type="checkbox" name="barwione brzegi" value="tak" id='c1'   />
        <img loading="lazy" alt="Dyed edges" className='obrazek lazyload' src="/img/dodatki/dodatki_barwione_brzegi_942-100x100.jpg" width='100px' />
        <br />
        <b>Dyed edges</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>possibility of coloring the edges of the calendar block or notebook<br /> - minimum 100 pieces</p>
      </div>

      <div className='column'>
      <label htmlFor='c2' className='main kmain'>
        <input onChange={this.handleChange}  type="checkbox" name="gumka grzbietowa" value="tak" id='c2' />
        <img loading="lazy" alt="Back eraser" className='obrazek lazyload' src="/img/dodatki/dodatki_gumka_grzbietowa_738-100x100.jpg" width='100px' />
        <br />
        <b>Back eraser</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>pen slot,<br /> rubber 10 mm</p>
      </div>

      <div className='column'>
      <label htmlFor='c3' className='main kmain'>
        <input onChange={this.handleChange}  type="checkbox" name="gumka pionowa" value="tak" id='c3' />
        <img loading="lazy" alt="Vertical eraser" className='obrazek lazyload' src="/img/dodatki/dodatki_gumka_pionowa_354-100x100.jpg" width='100px' />
        <br />
        <b>Vertical eraser</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>rubber 10 mm</p>
      </div>

      <div className='column'>
      <label htmlFor='c4' className='main kmain'>
        <input onChange={this.handleChange}  type="checkbox" name="gumka pozioma" value="tak" id='c4' />
        <img loading="lazy" alt="Horizontal eraser" className='obrazek lazyload' src="/img/dodatki/dodatki_gumka_pozioma_234-100x100.jpg" width='100px' />
        <br />
        <b>Horizontal eraser</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>pen slot,<br /> rubber 10 mm</p>
      </div>

      <div className='column'>
      <label htmlFor='c5' className='main kmain'>
        <input onChange={this.handleChange}  type="checkbox" name="koperta" value="tak" id='c5' />
        <img loading="lazy" alt="Envelope" className='obrazek lazyload' src="/img/dodatki/dodatki_koperta_493-100x100.jpg" width='100px' />
        <br />
        <b>Envelope</b>
      </label>
        <p style={{fontSize:'10px', color:'#828282'}}><b>dimension</b> | any format</p>
      </div>

      <div className='column'>
      <label htmlFor='c6'  className='main kmain'>
        <input onChange={this.handleChange}  type="checkbox" name="kryształ" value="tak" id='c6' />
        <img loading="lazy" alt="Swarovski crystal" className='obrazek lazyload' src="/img/dodatki/dodatki_krysztal_779-100x100.jpg" width='100px' />
        <br />
        <b>Swarovski crystal</b>
      </label>
        <p style={{fontSize:'10px', color:'#828282'}}>glued to the binding <br /> size | 10 x 10 mm</p>
      </div>


      </div>




    <div className="columns" style={{textAlign:'left',marginLeft:'20px',flexWrap:'wrap'}}>

    <div className='column'>
      <label htmlFor='c7'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c7' name="m1" value="tak"  />
        <img loading="lazy" alt="m1" className='obrazek lazyload' src="/img/dodatki/dodatki_m1_859-100x100.jpg" width='100px' />
        <br />
        <b>M1</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>plate brushed aluminum for engraving
       <br />
        <b>size</b> | 40 x 14 mm
         <br />
        <b>engraving area</b> | 38 x 12 mm </p>
      </div>



      <div className='column'>
      <label htmlFor='c8'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c8' name="m2" value="tak"  />
        <img loading="lazy" alt="m2" className='obrazek lazyload' src="/img/dodatki/dodatki_m2_288-100x100.jpg" width='100px' />
        <br />
        <b>M2</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>plate brushed aluminum for engraving with embossed year
       <br />
        <b>size</b> | 40 x 14 mm
         <br />
        <b>engraving area</b> | 26 x 12 mm </p>
        </div>




        <div className='column'>
      <label htmlFor='c9'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c9' name="m3" value="tak"  />
        <img loading="lazy" alt="m3" className='obrazek lazyload' src="/img/dodatki/dodatki_m3_105-100x100.jpg" width='100px' />
        <br />
        <b>M3</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>finochrome year glued to the binding
       <br />
        <b>size</b> | 45 x 9 mm </p>
      </div>



      <div className='column'>
      <label htmlFor='c10'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c10' name="m4" value="tak"  />
        <img loading="lazy" alt="m4" className='obrazek lazyload' src="/img/dodatki/dodatki_m4_724-100x100.jpg" width='100px' />
        <br />
        <b>M4</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>finochrome year glued to the binding
       <br />
        <b>size</b> | 10 x 10 mm </p>
      </div>

      <div className='column'>
      <label htmlFor='c11'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c11' name="m11" value="tak"  />
        <img loading="lazy" alt="m11" className='obrazek lazyload' src="/img/dodatki/dodatki_m11_563-100x100.jpg" width='100px' />
        <br />
        <b>M11</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>metal clasp (matte silver) fastened by a rivet with a metal hinge that closes with a magnet <br />
      <b>engraving area</b> | 26 x 8 mm</p>
      </div>

      <div className='column'>
      <label htmlFor='c12'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c12' name="m14" value="tak"  />
        <img loading="lazy" alt="m14" className='obrazek lazyload' src="/img/dodatki/dodatki_m14_116-100x100.jpg" width='100px' />
        <br />
        <b>M14</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>square sheet (silver glitter) attached to cover with 2 mm rubber band<br />
      <b>engraving area</b> | 15 x 15 mm</p>
      </div>






    </div>


    <div className="columns" style={{textAlign:'left',marginLeft:'20px',flexWrap:'wrap'}}>

    <div className='column'>
      <label htmlFor='c13'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c13' name="m15" value="tak"  />
        <img loading="lazy" alt="m15" className='obrazek lazyload' src="/img/dodatki/dodatki_m15_967-100x100.jpg" width='100px' />
        <br />
        <b>M15</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>rectangular tin (matte silver) mounted on a 10 mm rubber band<br />
      <b>engraving area</b> | 34 x 12 mm</p>
    </div>

      <div className='column'>
      <label htmlFor='c14'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c14' name="magnes" value="tak"  />
        <img loading="lazy" alt="Magnet patch" className='obrazek lazyload' src="/img/dodatki/dodatki_patka-magnes_660-100x100.jpg" width='100px' />
        <br />
        <b>Magnet patch</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>closed with a magnet with a place for a pen magnet hidden in the binding<br />
      <b>engraving area</b> | 8 x 8 mm</p>
      </div>

      <div className='column'>
      <label htmlFor='c15'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c15' name="pendrive" value="tak"  />
        <img loading="lazy" alt="pendrive 16gb" className='obrazek lazyload' src="/img/dodatki/dodatki_pendrive_112-100x100.jpg" width='100px' />
        <br />
        <b>Pendrive 16GB </b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}><b>size</b> | 34 x 11 mm
      <br />
      <b>engraving area</b> | 28 x 8 mm</p>
      </div>

      <div className='column'>
      <label htmlFor='c16'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c16' name="grawer" value="tak"  />
        <img loading="lazy" alt="Engraved personalization" className='obrazek lazyload' src="/img/dodatki/dodatki_personalizacja-grawer_777-100x100.jpg" width='100px' />
        <br />
        <b>Engraved personalization</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>personalization by design </p>
      </div>


      <div className='column'>
      <label htmlFor='c17'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c17' name="tloczenie" value="tak"  />
        <img loading="lazy" alt="Embossed personalization" className='obrazek lazyload' src="/img/dodatki/dodatki_personalizacja-tloczenie_186-100x100.jpg" width='100px' />
        <br />
        <b>Embossed personalization</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}><b>font</b> | latin it capital 4 mm </p>
      </div>

      <div className='column'>
      <label htmlFor='c18'  className='kmain main'>
        <input onChange={this.handleChange}  type="checkbox" id='c18' name="kieszonka prostokatna" value="tak"  />
        <img loading="lazy" alt="Rectangular pocket" className='obrazek lazyload' src="/img/dodatki/dodatki_prostokatna-kieszonka_923-100x100.jpg" width='100px' />
        <br />
        <b>Rectangular pocket</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>Pocket made of foil <br />
      <b>size</b> | 90 x 60 mm</p>
      </div>






    </div>

    <div className="columns" style={{textAlign:'left',marginLeft:'20px',flexWrap:'wrap'}}>



    <div className='column'>
      <label htmlFor='c19'  className='kmain main'>
        <input onChange={this.handleChange} type="checkbox" id='c19' name="szlufka" value="tak"  />
        <img loading="lazy" alt="A loop for a pen" className='obrazek lazyload' src="/img/dodatki/dodatki_szlufka_na_dlugopis_226-100x100.jpg" width='100px' />
        <br />
        <b>A loop for a pen</b>
      </label>
        <p style={{fontSize:'10px', color:'#828282'}}>10 mm rubber</p>
      </div>


      <div className='column'>
      <label htmlFor='c20'  className='kmain main'>
        <input onChange={this.handleChange} type="checkbox" id='c20' name="tasiemki" value="tak"  />
        <img loading="lazy" alt="Tapestries" className='obrazek lazyload' src="/img/dodatki/dodatki_tasiemki_581-100x100.jpg" width='100px' />
        <br />
        <b>Tapestries</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>woven, sublimation ribbons</p>
      </div>


      <div className='column'>
      <label htmlFor='c21'  className='kmain main'>
        <input onChange={this.handleChange} type="checkbox" id='c21' name="kieszonka trojkatna" value="tak"  />
        <img loading="lazy" alt="Triangular pocket" className='obrazek lazyload' src="/img/dodatki/dodatki_trojkatna-kieszonka_750-100x100.jpg" width='100px' />
        <br />
        <b>Triangular pocket</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>
      Pocket made of foil<br />
      <b>size</b> | 80 x 80 mm,
      100 x 100 mm, 120 x 120 mm
      </p>
      </div>


      <div className='column'>
      <label htmlFor='c22'  className='kmain main'>
        <input onChange={this.handleChange} type="checkbox" id='c22' name="uchwyt" value="tak"  />
        <img loading="lazy" alt="Pen holder" className='obrazek lazyload' src="/img/dodatki/dodatki_uchwyt_959-100x100.jpg" width='100px' />
        <br />
        <b>Pen holder</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>handle made of eco-leather </p>
      </div>


      <div className='column'>
      <label htmlFor='cx23'  className='kmain main'>
        <input onChange={this.handleChange} type="checkbox" id='cx23' name="rok tloczony" value="tak"  />
        <img loading="lazy" alt="Year pressed" className='obrazek lazyload' src="/img/dodatki/dodatki_rok_tloczony.jpg" width='100px' />
        <br />
        <b>Year pressed</b>
      </label>
      <p style={{fontSize:'10px', color:'#828282'}}>current year stamped on the cover</p>
      </div>

      <span className='column'>

      </span>


    </div>




    <label className='label' style={{marginLeft:'15px'}}>Rubber:</label>
    <br />

    <div>

    <AliceCarousel autoPlayInterval="5000">
    <div>
    <label key="d1" className="gumki">
        <input type="radio" name="gumki" value="zielony" onChange={this.handleChange}  />
        <img alt="additives rubber band green" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_zielony.png" />
      </label>
      <label  key="d2" className="gumki" >
          <input type="radio" name="gumki" value="czarny" onChange={this.handleChange}  />
          <img alt="accessories rubber band black" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_czarny.png" />
        </label>
        <label key="d3" className="gumki" >
            <input type="radio" name="gumki" value="pomaranczowy" onChange={this.handleChange}  />
            <img alt="additives rubber band orange" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_pomaranczowy.png" />
          </label>
          <label key="d4" className="gumki" >
              <input type="radio" name="gumki" value="magenta" onChange={this.handleChange}  />
              <img alt="additives magenta eraser" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_magenta.png" />
            </label>
            <label key="d5" className="gumki" >
                <input type="radio" name="gumki" value="multicolor" onChange={this.handleChange}  />
                <img alt="additives multicolor rubber band" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_multicolor.png" />
              </label>
        </div>
        <div>
              <label key="d6" className="gumki" >
                  <input type="radio" name="gumki" value="niebieski" onChange={this.handleChange}  />
                  <img alt="accessories rubber band blue" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_niebieski.png" />
                </label>
                <label key="d7" className="gumki" >
                    <input type="radio" name="gumki" value="fioletowy" onChange={this.handleChange}  />
                    <img alt="accessories rubber band purple" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_fioletowy.png" />
                  </label>
                  <label key="d8" className="gumki" >
                      <input type="radio" name="gumki" value="granatowy" onChange={this.handleChange}  />
                      <img alt="accessories rubber band navy blue" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_granatowy.png" />
                    </label>
                    <label key="d9" className="gumki" >
                        <input type="radio" name="gumki" value="czerwony" onChange={this.handleChange}  />
                        <img alt="accessories rubber band red" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_czerwony.png" />
                      </label>
                      <label key="d10" className="gumki" >
                          <input type="radio" name="gumki" value="ciemnogranatowy" onChange={this.handleChange}  />
                          <img alt="accessories dark blue rubber band" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_ciemnogranatowy.png" />
                        </label>
                      </div>

                      <div>
                        <label key="d11" className="gumki" >
                            <input type="radio" name="gumki" value="brazowy" onChange={this.handleChange}  />
                            <img alt="accessories rubber band brown" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_brazowy.png" />
                          </label>
                          <label key="d12" className="gumki" >
                              <input type="radio" name="gumki" value="seledynowy" onChange={this.handleChange}  />
                              <img alt="additions rubber band celadon" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_seledynowy.png" />
                            </label>
                            <label key="d13" className="gumki" >
                                <input type="radio" name="gumki" value="szary" onChange={this.handleChange}  />
                                <img alt="accessories rubber band grey" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_szary.png" />
                              </label>
                                <label key="d15" className="gumki" >
                                    <input type="radio" name="gumki" value="zolty" onChange={this.handleChange}  />
                                    <img alt="accessories rubber band yellow" className="obrazek lazyload" loading="lazy" src="/img/gumki/gumka_zolty.png" />
                                  </label>
                              </div>
    </AliceCarousel>

    <div className='columns'>
    <div className='column'>
      <div className='control' style={{textAlign:'center'}}>
      <label className='label is-size-10'>Attach a design from the <a href="/calendar-creator-online/" className="inline-link" target="_blank"><strong>calendar creator</strong></a>:</label>
      {/*załącz logo*/}


       </div>
       </div>
      <div className='column'>
      <div className="file" style={{textAlign:'center'}}>
        <label className="file-label" style={{width:'100%',cursor:'pointer'}}>
        {/*onInput ={(o) => handleInput(o)}*/}
          <input
            className="custom-file-input"
            type="file"
            name="plik"
            style={{width:'100%',cursor:'pointer'}}
            onChange={this.handleAttachment}
            id ="fileinputIIIII"
          />
     </label>
     </div>
     <br></br>
      <p align="center" style={{backgroundColor:'#111111',color:'white',padding:'2px',fontSize:'12px'}}> The maximum file size is <b>1MB</b>. </p>
      </div>
    </div>
    </div>

      <hr />


         {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
         <input type="hidden" name="form-name" value="Kalendarze książkowe" />
         <div hidden>
           <label>
             Don’t fill this out:{' '}
             <input name="bot-field"
             onChange={this.handleChange}
             />
           </label>
         </div>

         <div className="columns">
         <div className='column' style={{marginLeft:'15px'}}>
         <div className="field">
           <label className="label" htmlFor={'name'}>
             Name and Surname<sup>*</sup>:
           </label>
           <div className="control">
             <input
               className="input"
               type={'text'}
               name={'imię i nazwisko'}
               onChange={this.handleChange}
               id={'imię i nazwiskoV'}
               required={true}
             />
           </div>
           </div>

           <div className="field">
             <label className="label" htmlFor={'email'}>
               E-mail address<sup>*</sup>:
             </label>
             <div className="control">
               <input
                 className="input"
                 type={'email'}
                 name={'adres email'}
                 onChange={this.handleChange}
                 id={'adres emailVIII'}
                 required={true}
               />
             </div>
           </div>

           <div className="field ">
             <label className="label" htmlFor={'phone'}>
               Phone number<sup>*</sup>:
             </label>
             <div className="control">
               <input
                 className="input"
                 type={'tel'}
                 name={'numer telefonu'} required={true}
                 onChange={this.handleChange}
                 id={'nrtelV'}
               />
             </div>
           </div>


         </div>

         <div className="field column" style={{marginLeft:'15px'}}>
           <label className="label" htmlFor={'message'}>
             Message<sup>*</sup>:
           </label>
           <div className="control">
             <textarea
               className="textarea"
               type={'text'}
               name={'wiadomość'}
               onChange={this.handleChange}
               id={'wiadomośćV'}
               required={true}
               rows = "7"
             ></textarea>
           </div>



           <br />
           <div className="control">

           <label style={{fontSize: '12px'}} className='main'  htmlFor="privacyV">   <input required={true} onChange={this.handleChange} type="checkbox" id="privacyV" name="privacy"  value="true"/>I consent to the processing of my data in accordance with our <a className='link-green' href="/privacy-policy/">privacy policy</a><sup>*</sup>.<span className="check"></span></label>            </div>

           <div className="field" style={{textAlign:'right'}}>


             <button className="button is-primary" type="submit" onSubmit={this.handleSubmit}>
               Send
             </button>



           </div>


         </div>



         </div>

</form>












      </>
    )
  }
}




let savana = ['bezowy','bordowy','brazowy','granatowy','','','','','',''];
let bambus = ['granatowy','seledynowy','szary','zielony','','','','','',''];
let natura = ['bezowy','grafitowy','granatowy','szary','','','','','',''];
let canvas = ['brazowy','czarny','czerwony','granatowy','niebieski','szary','zielony','','',''];
let kraft = ['grafitowy','granatowy','koralowy','niebieski','','','','','',''];
let vivela = ['czarny','czerwony','granatowy','magenta','pomaranczowy','seledynowy','szary','turkusowy','zielony','zolty'];
let image = ['bordowy','czarny','czekoladowy','grafitowy','granatowy','szary','','','',''];

let ideo = ['bialy','czarny','czerwony','granatowy','seledynowy','','','','',''];
let carbon = ['czarny','granatowy','szary','','','','','','',''];
let cross = ['czarny','czerwony','granatowy','szary','zielony','','','','',''];
let guma = ['czarny-satynowy','czerwony','granat-satynowy','mietowy','niebieski','pomaranczowy','szary-satynowy','','',''];
let piko = ['brazowy','czarny','czerwony','fioletowy','granatowy-blysk','granatowy-mat','srebrny','szary','',''];
let holo = ['hologram','','','','','','','','',''];
let flesz = ['grafitowy','srebrny','zloty','','','','','','',''];

let aluminium = ['czarny','granatowy','srebrny','','','','','','',''];
let outletzamsz = ['granatowy','','','','','','','','',''];
let outletduro = ['czarny','granatowy','szary','','','','','','',''];
let outletfabra = ['zielony','','','','','','','','',''];
let outletcolorado = ['bordowy','szary','','','','','','','',''];
let outletcross = ['czekoladowy','malinowy','','','','','','','',''];
let outletjuta = ['brazowy','','','','','','','','',''];






const changeOne = (num) => (event) =>{

  let colors = document.getElementsByClassName('koloroprawy');
  let pictures = document.getElementsByClassName('oprawaimg');
  let name = event.target.innerText //.toLowerCase();
  name = name.replace(/\s/g, '');

  var collection;
if (num == 0){
  collection = savana;
}
  else if (num == 1){
  collection = bambus;
}
  else if (num == 2) {
  collection = natura;
}
  else if (num == 3) {
  collection = canvas;
}
  else if (num == 4) {
  collection = kraft;
}
  else if (num == 5) {
  collection = vivela;
}
  else if (num == 6) {
  collection = image;
}
  else if (num == 7) {
  collection = ideo;
}
  else if (num == 8) {
    collection = carbon;
  }
  else if (num == 9) {
    collection = cross;
  }
  else if (num == 10){
  collection = guma;
}
  else if (num == 11) {
  collection = piko;
}
  else if (num == 12) {
  collection = holo;
}
  else if (num == 13) {
  collection = flesz;
}
  else if (num == 14) {
  collection = aluminium;
  }
  else if (num == 15) {
  collection = outletzamsz;
}
  else if (num == 16) {
  collection = outletduro;
}
  else if (num == 17) {
  collection = outletfabra;
}
  else if (num == 18) {
    collection = outletcolorado;
  }
  else if (num == 19) {
    collection = outletcross;
  }
  else if (num == 20) {
    collection = outletjuta;
  }




  console.log(collection)


      colors[0].value =  name + ' ' + collection[0];
      pictures[0].src = '/img/oprawy/'+name+'__'+collection[0]+'.png';
      console.log(colors[0].value)

      colors[1].value =  name + ' ' + collection[1];
      pictures[1].src = '/img/oprawy/'+name+'__'+collection[1]+'.png';


      colors[2].value =  name + ' ' + collection[2];
      pictures[2].src = '/img/oprawy/'+name+'__'+collection[2]+'.png';


      colors[3].value =  name + ' ' + collection[3];
      pictures[3].src = '/img/oprawy/'+name+'__'+collection[3]+'.png';


      colors[4].value =  name + ' ' + collection[4];
      pictures[4].src = '/img/oprawy/'+name+'__'+collection[4]+'.png';


      colors[5].value =  name + ' ' + collection[5];
      pictures[5].src = '/img/oprawy/'+name+'__'+collection[5]+'.png';


      colors[6].value =  name + collection[6];
      pictures[6].src = '/img/oprawy/'+name+'__'+collection[6]+'.png';


      colors[7].value =  name + collection[7];
      pictures[7].src = '/img/oprawy/'+name+'__'+collection[7]+'.png';

      colors[8].value =  name + collection[8];
      pictures[8].src = '/img/oprawy/'+name+'__'+collection[8]+'.png';

      colors[9].value =  name + collection[9];
      pictures[9].src = '/img/oprawy/'+name+'__'+collection[9]+'.png';

      for (let i = 0; i < collection.length; i++){
        if (collection[i] === ''){
        pictures[i].src = ' ';
        pictures[i].style.display = 'none';
        colors[i].setAttribute("disabled","true");
      } else {
        colors[i].removeAttribute("disabled");
        pictures[i].style.display = 'flex';

      }
    }
    colors[0].checked = 'true';



}




export default KalKsia;
